import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "top-content" }
const _hoisted_2 = { class: "user-name" }
const _hoisted_3 = { class: "user-info" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field-value" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "field-value" }
const _hoisted_8 = {
  key: 0,
  class: "field"
}
const _hoisted_9 = { class: "credentials-list" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { key: 3 }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { key: 4 }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "rating-container" }
const _hoisted_21 = ["src"]

import { getCertificationImageSrc } from '@/helpers/CertificationsHelper';
import { getStars } from '@/helpers/RatingHelper';
import { CertificationType, PublicCustomerProfile } from '@/models/backend/CustomerModels';
import { ref, watch } from 'vue';
import { CustomerProfileService } from '@/services/backend/CustomerService';
import { showExceptionAlert } from '@/helpers/SweetAlertHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfoComponent',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;
const userInfo = ref({} as PublicCustomerProfile);
const isLoading = ref<boolean>(false);

const getUserInfo = async () => {
	try {
        isLoading.value = true;
		
        const response = await CustomerProfileService.getPublicCustomerProfile(props.userId);
        if(response!=null){
            userInfo.value = response;
        }

	} catch (error) {
		showExceptionAlert(error);
	} finally {
        isLoading.value = false;
    }
}

watch(() => props.userId, () => {
    getUserInfo()
}, { deep: true, immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(userInfo.value.name), 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "verified" }, [
        _createTextVNode("verificado"),
        _createElementVNode("i", { class: "bp-icon-Verified" })
      ], -1))
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "field-label" }, "Nombre", -1)),
        _createElementVNode("span", _hoisted_5, _toDisplayString(userInfo.value.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "field-label" }, "Código postal", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(userInfo.value.postalCode), 1)
      ]),
      (userInfo.value.certifications)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "field-label" }, "Acreditaciones:", -1)),
            _createElementVNode("ul", _hoisted_9, [
              (userInfo.value.certifications.includes(_unref(CertificationType).ISO9001))
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createElementVNode("img", {
                      class: "cert-img",
                      src: _unref(getCertificationImageSrc)(_unref(CertificationType).ISO9001),
                      alt: _unref(CertificationType).ISO9001
                    }, null, 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (userInfo.value.certifications.includes(_unref(CertificationType).ISO14001))
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createElementVNode("img", {
                      class: "cert-img",
                      src: _unref(getCertificationImageSrc)(_unref(CertificationType).ISO14001),
                      alt: _unref(CertificationType).ISO14001
                    }, null, 8, _hoisted_13)
                  ]))
                : _createCommentVNode("", true),
              (userInfo.value.certifications.includes(_unref(CertificationType).ANREPA))
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    _createElementVNode("img", {
                      class: "cert-img",
                      src: _unref(getCertificationImageSrc)(_unref(CertificationType).ANREPA),
                      alt: _unref(CertificationType).ANREPA
                    }, null, 8, _hoisted_15)
                  ]))
                : _createCommentVNode("", true),
              (userInfo.value.certifications.includes(_unref(CertificationType).EPAL))
                ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                    _createElementVNode("img", {
                      class: "cert-img",
                      src: _unref(getCertificationImageSrc)(_unref(CertificationType).EPAL),
                      alt: _unref(CertificationType).EPAL
                    }, null, 8, _hoisted_17)
                  ]))
                : _createCommentVNode("", true),
              (userInfo.value.certifications.includes(_unref(CertificationType).NIMA))
                ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                    _createElementVNode("img", {
                      class: "cert-img",
                      src: _unref(getCertificationImageSrc)(_unref(CertificationType).NIMA),
                      alt: _unref(CertificationType).NIMA
                    }, null, 8, _hoisted_19)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_20, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "h3-title" }, "Valoraciones", -1)),
      _createElementVNode("img", {
        class: "stars",
        src: _unref(getStars)((userInfo.value.rating) ? userInfo.value.rating : 0),
        alt: "Valoración"
      }, null, 8, _hoisted_21)
    ])
  ], 64))
}
}

})